<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>
<!-- Main content Start -->
<div class="main-content">
  <!-- Breadcrumbs Start -->
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/6.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color padding">
      <h1 class="page-title">Grievance form</h1>
      <ul>
        <li>
          <a class="active" href="/">Home</a>
        </li>
        <li>Grievance form</li>
      </ul>
    </div>
  </div>
  <!-- Breadcrumbs End -->
  <!-- Contact Section Start -->
  <div class="contact-page-section pt-100 pb-100 md-pt-70 md-pb-70">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 pl-30 lg-pl-15 blog-table-wrap">
          <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScYyZkJo2PoN3RsZzMbKDd9UXe0L3NpQ3NAS0zpo_PfYyKg-Q/viewform?embedded=true" width="640" height="1734" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>    </div>
      </div>
    </div>
  </div>
  <!-- Contact Section End -->
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->
